import { render, staticRenderFns } from "./HorizontalBarChart.vue?vue&type=template&id=8b6db0ac&scoped=true"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"
import style0 from "./HorizontalBarChart.vue?vue&type=style&index=0&id=8b6db0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6db0ac",
  null
  
)

export default component.exports